import { bff, toClientError } from './bff'

const run = (p) => p.then((r) => r.data).catch((e) => Promise.reject(toClientError(e)))

// Capability for a raw input (BFF detects the source) or for a known source.
export const getCapabilities = (input, source) =>
  run(bff.get('/api/import/capabilities', { params: { input: input || undefined, source: source || undefined } }))

// Submit an import job from a URL (maps the selected steps to transcribe_video).
export const submitImport = (body) => run(bff.post('/api/import/jobs', body))

// Submit an import job from an uploaded local media file.
export const uploadImport = ({ file, options }) => {
  const fd = new FormData()
  fd.append('options', JSON.stringify(options))
  fd.append('file', file, file.name)
  return run(
    bff.post('/api/import/upload', fd, { headers: { 'Content-Type': undefined } })
  )
}

// Poll job status (progress + outputs).
export const getImportJob = (id) => run(bff.get(`/api/import/jobs/${id}`))

// Index a completed job's artifact into a local-rag project. Omit `artifact`
// to let the BFF pick (subtitles when available — carries timestamps).
export const indexImportJob = ({ id, project, artifact, language }) =>
  run(bff.post(`/api/import/jobs/${id}/index`, { project, artifact, language }))

// Durable background operation state (Stage 2 sagas): poll → index survives
// closed tabs and BFF restarts; the UI just watches.
export const getSagaStatus = (id) => run(bff.get(`/api/sagas/${id}`))
